import { clsx } from 'clsx';

export const APP_BG_COLOR = 'tw:bg-zinc-50';
export const STICKY_HEADER = clsx('tw:sticky', 'tw:top-0', 'tw:z-10', APP_BG_COLOR);

// COMMON DRAWER STYLES
export const READ_ONLY_LABEL_STYLE: string = 'tw:text-zinc-400 tw:!font-medium tw:text-xs';
export const READ_ONLY_VALUE_STYLE: string = 'tw:font-medium';
